import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { GbBaseApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-base-api.service'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { Observable } from 'rxjs'
import { GbFrontCookieService } from 'libs/gb-front/auth/util/src'
import { CreateCustomValuePayload, CustomValuesEntity, ProfileEntity } from './selected-profile.models'

@Injectable({
  providedIn: 'root',
})
export class SelectedProfileApiService extends GbBaseApiService {
  get isVolunteer(): boolean {
    return this.gbFrontCookieService.isVolunteer()
  }

  constructor(
    protected http: HttpClient,
    @Inject(APP_CONFIG) protected appConfig: any,
    private gbFrontCookieService: GbFrontCookieService,
  ) {
    super(http, appConfig)
  }

  updateProfile(urlName: string, profile: Partial<ProfileEntity>, profileUuid?: string): Observable<ProfileEntity> {
    let url = `auctions/${urlName}/me/profile/`

    if (this.isVolunteer) {
      url = `auctions/${urlName}/profiles/${profileUuid}/`
    }

    return this.patch<ProfileEntity>(url, profile)
  }

  syncProfile(urlName: string, profileUuid?: string): Observable<ProfileEntity> {
    let url = `auctions/${urlName}/me/profile/`
    if (this.isVolunteer) url = `auctions/${urlName}/profiles/${profileUuid}/`
    return this.get<ProfileEntity>(url)
  }

  createCustomValue(createCustomValuePayload: CreateCustomValuePayload): Observable<CustomValuesEntity> {
    const url = `auctions/${createCustomValuePayload.auction}/registration-custom-values/`
    return this.post(url, createCustomValuePayload)
  }

  updateCustomValue(customValue: CustomValuesEntity): Observable<CustomValuesEntity> {
    const url = `auctions/${customValue.auction}/registration-custom-values/${customValue.uuid}/`
    return this.patch(url, customValue)
  }

  completeProfile(urlName: string, update: any, profileUuid?: string): Observable<ProfileEntity> {
    const url = `auctions/${urlName}/complete-profile/`
    const payload = { ...update, uuid: profileUuid }
    return this.post(url, payload)
  }
}
